import { useAppSelector } from 'store/hook';
import { useTagData } from '../hooks/useTagData';
import IndividualSensorAnalysisCard from './IndividualSensorAnalysisCard';
import { GroupedChartNew } from '../SensorAnalysisView/Content/Chart/Grouped/Chart';

const IndividualSensorChartView = () => {
  const { sortedSelectedTags } = useTagData();
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
      }}
    >
      {sortedSelectedTags.map((tag, index) => {
        return (
          <IndividualSensorAnalysisCard key={index} tag={tag} index={index} />
        );
      })}
    </div>
  );
};

const GroupedSensorChartView = () => {
  return (
    <>
      <GroupedChartNew />
    </>
  );
};
export const SensorAnalysisCharts = () => {
  const chartType = useAppSelector(
    (store) => store.sensorAnalysisReducer.chartType
  );

  return (
    <>
      {chartType === 'Individual' && <IndividualSensorChartView />}
      {chartType === 'Grouped' && <GroupedSensorChartView />}
    </>
  );
};

export default SensorAnalysisCharts;
